module.exports = __webpack_public_path__ + "static/img/item-1.0c3ebe64.png";